import { graphql } from '../../generated';

export const SCHEDULE_IMPORT = graphql(`
  mutation ScheduleImport($type: String!, $params: JSON!, $file: Upload!) {
    scheduleImport(input: { type: $type, file: $file, params: $params }) {
      import {
        id
        status
        modifications
      }
    }
  }
`);

export const POLL_IMPORT = graphql(`
  query PollImport($id: ID!) {
    import(id: $id) {
      id
      status
      modifications
    }
  }
`);
